import { useLazyQuery as useApolloLazyQuery } from '@apollo/client'

import agentClient from '@/lib/apollo/client/agent'
import type { WrappedUseLazyQuery } from '@/lib/apollo/types'

import type { QueryVars, Response } from './query'
import getExecutivesBySquad from './query'

export const useLazyQuery: WrappedUseLazyQuery<Response, QueryVars> = (options = {}) =>
  useApolloLazyQuery<Response, QueryVars>(getExecutivesBySquad, {
    client: agentClient,
    fetchPolicy: 'network-only',
    nextFetchPolicy: 'network-only',
    ...options,
  })
